export const actions = {
    axn_purchasedVoices({ commit }, voice) {
        commit('set_purchasedVoices', voice);
    },

    axn_loadPanelConfiguredVoices({ commit }, voices) {
        commit('set_loadPanelConfiguredVoices', voices);
    },

    axn_expireVoice({ commit }, id) {
        commit('set_expireVoice', id);
    },

    axn_panelMinimumTime({ commit }, minimumTime) {
        if (!minimumTime) return;

        commit('set_panelMinimumTime', minimumTime);
    },
};
